import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { useCallback } from 'react'
import useItemsSetter from 'recoil/useItemsSetter'
import useTableWithRequest from 'shared/Table/useTableWithRequest'
import Table from 'shared/Table'
import projectTypesApi from '../../projectTypes.api'
import projectTypesTableFields from './projectTypesTableFields'
import { IProjectType } from '../../projectTypes.types'
import projectTypesTableAtom from './projectTypesTable.atom'
import { useProjectStagesState } from '../../hooks/useProjectStagesState'
import { useAllCheckpointsState } from 'screens/Admin/ProjectCheckpoints/hooks/useAllCheckpointsState'

const ProjectTypesTable = () => {
  const navigate = useNavigate()
  const state = useRecoilValue(projectTypesTableAtom)
  const { projectStagesMap } = useProjectStagesState()
  const { checkpointsMap } = useAllCheckpointsState()

  const fetcher = useCallback((_params: Record<string, any>) => {
    return projectTypesApi.getList()
  }, [])

  const itemsSetter = useItemsSetter(projectTypesTableAtom)

  const tableCtrl = useTableWithRequest({
    dataFetcher: fetcher,
    fields: projectTypesTableFields(projectStagesMap, checkpointsMap),
    itemKey: 'id',
    items: state.items,
    setItems: itemsSetter,
    tableKey: 'project-types',
  })

  const handleClick = useCallback((projectType: IProjectType) => {
    navigate(`/admin/project-types/${projectType.id}`)
  }, [])

  return (
    <>
      <Table
        {...tableCtrl}
        items={tableCtrl.orderedItems}
        handleSelect={tableCtrl.selectedCtrl.setSelected}
        selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof IProjectType>}
        handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
        itemKey='id'
        onCLick={handleClick}
        selectEnabled={false}
      />
    </>
  )
}

export default ProjectTypesTable
